<template>
  <circle cx="18.5" cy="18.5" r="18.5" fill="#FFED00" />
  <circle cx="18.2992" cy="11.58" r="4.82998" stroke="#233F1F" stroke-width="1.5" />
  <path d="M18.2998 16.2297V19.0197" stroke="#233F1F" stroke-width="1.5" />
  <mask id="path-4-inside-1_2306_1231" fill="white">
    <path
      d="M27.5999 27.7002C27.5999 25.2337 26.6201 22.8682 24.876 21.1242C23.132 19.3801 20.7665 18.4003 18.3 18.4003C15.8335 18.4003 13.468 19.3801 11.7239 21.1242C9.97982 22.8682 9 25.2337 9 27.7002L18.3 27.7002H27.5999Z" />
  </mask>
  <path
    d="M27.5999 27.7002C27.5999 25.2337 26.6201 22.8682 24.876 21.1242C23.132 19.3801 20.7665 18.4003 18.3 18.4003C15.8335 18.4003 13.468 19.3801 11.7239 21.1242C9.97982 22.8682 9 25.2337 9 27.7002L18.3 27.7002H27.5999Z"
    stroke="#233F1F"
    stroke-width="3"
    mask="url(#path-4-inside-1_2306_1231)" />
</template>
